import { defineMessages } from 'react-intl';

export const messages: {
	exampleHideText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	exampleMoreAppsText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	exampleProductChatLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	exampleProductConfluenceLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	exampleProductJiraLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	exampleSwitcherText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	exampleSwitcherText: {
		id: 'navigation.ribbon.navigation-ribbon.switcher.example-label',
		description: 'Example switcher label in the navigation ribbon example.',
		defaultMessage: 'Switcher',
	},
	exampleMoreAppsText: {
		id: 'navigation.ribbon.navigation-ribbon.more-apps.example-label',
		description: 'Example more apps label in the navigation ribbon example.',
		defaultMessage: 'More Apps',
	},
	exampleHideText: {
		id: 'navigation.ribbon.navigation-ribbon.hide.example-label',
		description: 'Example hide label in the navigation ribbon example.',
		defaultMessage: 'Hide',
	},
	exampleProductConfluenceLabel: {
		id: 'navigation.ribbon.navigation-ribbon.product.confluence.label',
		description: 'Label for Confluence product tile in the navigation ribbon example.',
		defaultMessage: 'Confluence',
	},
	exampleProductJiraLabel: {
		id: 'navigation.ribbon.navigation-ribbon.product.jira.label',
		description: 'Label for Jira product tile in the navigation ribbon example.',
		defaultMessage: 'Jira',
	},
	exampleProductChatLabel: {
		id: 'navigation.ribbon.navigation-ribbon.product.chat.label',
		description: 'Label for Chat product tile in the navigation ribbon example.',
		defaultMessage: 'Chat',
	},
});
